import { watch } from 'vue'
import { defineStore } from 'pinia'
import { session } from '@/plugins/supabase'
import * as state from './state'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

export type { TokenUsage, AiConversationInfo, AiMessageInfo } from './types'
export { formatTokenCount } from './types'

export const useAiStore = defineStore('ai', () => {
  void mutations.hydrate()

  // Recharge les skills utilisateur depuis Supabase à chaque (re)connexion ;
  // vide à la déconnexion.
  watch(session, () => {
    void mutations.hydrate(true)
  })

  return {
    ...state,
    ...getters,
    ...mutations,
    ...actions
  }
})
